
import Vue from 'vue'

interface LoaderData {}

interface LoaderMethods {}

interface LoaderComputed {
    loading: boolean
}

interface LoaderProps {}

export default Vue.extend<LoaderData, LoaderMethods, LoaderComputed, LoaderProps>({
    name: 'LoaderComponent',
    computed: {
		loading() {
			return this.$store.state.loading
		},
	},
})
